import { Chip, useTheme } from '@mui/material'
import { NovaColours } from '@novafuturltd/core'
import dayjs from 'dayjs'

export const numberToSixDP = (value: any) => value?.toFixed(6)

export const numberWithCommas = (value: any, decimalPlaces?: number) => {
  const options = {}
  if (decimalPlaces) {
    Object.assign(options, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    })
  }
  return value?.toLocaleString('en-GB', options)
}

export const NumberWithCommasBox = ({
  value,
  decimalPlaces,
}: {
  value: any
  decimalPlaces?: number
}) => {
  return (
    <div
      style={{
        fontFeatureSettings: `'tnum' on, 'lnum' on`,
        letterSpacing: '-0.01em',
      }}
    >
      {numberWithCommas(value, decimalPlaces)}
    </div>
  )
}


export const BooleanFormatter = ({ value }: { value: boolean }) => {
  const theme = useTheme()
  return (
    <Chip
      label={value ? 'Yes' : 'No'}
      size="small"
      style={{
        backgroundColor: value
          ? NovaColours.RP010[theme.palette.mode]
          : NovaColours.N090[theme.palette.mode],
        border: value
          ? `1px solid ${NovaColours.RP080[theme.palette.mode]}`
          : `1px solid ${NovaColours.N060[theme.palette.mode]}`,
        color: value
          ? NovaColours.RP080[theme.palette.mode]
          : NovaColours.N020[theme.palette.mode],
      }}
    />
  )
}

export const DateFormatter = ({ value }: { value: string }) => {
  return <span>{value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '-'}</span>
}

export const IntervalFormatter = ({ value }: { value: number }) => {
  return <span>{value ? `${value}s` : '-'}</span>
}


export const BOT_TYPES_MAP = {
  helper: 'Helper',
  messenger: 'Messenger',
  coupon: 'Coupon',
}

export type BotTypeKey = keyof typeof BOT_TYPES_MAP


export const BotTypeFormatter = ({ value }: { value: BotTypeKey }) => {
  const theme = useTheme()
  return (
    <Chip
      label={BOT_TYPES_MAP[value]}
      size="small"
      style={{
        backgroundColor: NovaColours.N090[theme.palette.mode],
        border: `1px solid ${NovaColours.N060[theme.palette.mode]}`,
        color: NovaColours.N020[theme.palette.mode],
      }}
    />
  )
}

export const TruncateFormatter = ({ value }: { value: string }) => {
  const maxLength = 40
  if (!value) return null
  return (
    <span title={value}>
      {value.length > maxLength ? value.slice(0, maxLength) + '…' : value}
    </span>
  )
}